import { PropsWithChildren } from 'react';
import cn from 'classnames';
import { ShieldCheck, UserRound, Settings, X } from 'lucide-react';
import useUserProfile from '@/stores/user-profile';
import Logo from '@/assets/logo_d.svg?react';
import AccountSection from './sections/account';
import ProfileSection from './sections/profile';
import SettingSection from './sections/settings';

function AccountTab(props: PropsWithChildren & { active?: boolean; onClick: () => void }) {
  return (
    <div
      className={cn(
        'flex items-center text-sm gap-2 py-2 px-3 cursor-pointer',
        'text-[#09090B] rounded-[6px] transition',
        { 'bg-[#E5E5E5]/65': props.active, 'hover:bg-[#E5E5E5]/35': !props.active }
      )}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
}

export default function AccountPage() {
  const { currentTab, setCurrentTab, closeDialog } = useUserProfile();

  return (
    <div className="flex h-[90vh] max-h-[623px] min-w-0">
      <div className="px-3 py-5 bg-[#FAFAFA] w-[172px] flex flex-col gap-6 rounded-l-[8px]">
        <Logo />
        <div className="flex-1 flex flex-col gap-1 overflow-y-auto">
          <AccountTab active={currentTab === 'account'} onClick={() => setCurrentTab('account')}>
            <ShieldCheck size={16} color="#09090B" />
            <span>Account</span>
          </AccountTab>
          <AccountTab active={currentTab === 'profile'} onClick={() => setCurrentTab('profile')}>
            <UserRound size={16} color="#09090B" />
            <span>Profile</span>
          </AccountTab>
          <AccountTab active={currentTab === 'settings'} onClick={() => setCurrentTab('settings')}>
            <Settings size={16} color="#09090B" />
            <span>Settings</span>
          </AccountTab>
        </div>
      </div>
      <div className="flex-1 relative flex flex-col min-h-0 min-w-0">
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#E5E5E5]">
          <div className="text-xl font-semibold text-[#171717]">
            {currentTab === 'account' && <h2>Account</h2>}
            {currentTab === 'profile' && <h2>Profile</h2>}
            {currentTab === 'settings' && <h2>Settings</h2>}
          </div>

          <div className="">
            <X size={16} color="#525252" className="cursor-pointer" onClick={() => closeDialog()} />
          </div>
        </div>
        <div className="flex-1 relative overflow-y-auto min-w-0">
          {currentTab === 'account' && <AccountSection />}
          {currentTab === 'profile' && <ProfileSection />}
          {currentTab === 'settings' && <SettingSection />}
        </div>
      </div>
    </div>
  );
}
